var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRoundinline = function SvgArrowRoundinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 18.2c-1.1 1-2.9.9-3.9-.2s-.9-2.9.2-3.9l9.2-8.3c1.1-.9 2.6-.9 3.7 0l9.2 8.3c1.2 1 1.3 2.7.3 3.9-1 1.2-2.7 1.3-3.9.3l-.1-.1-7.3-6.6-7.4 6.6z"
  })));
};
export default SvgArrowRoundinline;